import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import type { PickersDayProps } from '@mui/x-date-pickers/PickersDay';

export default function ServerDay(props: PickersDayProps & { highlightedDays?: number[] }) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  const isHighlighted =
    !outsideCurrentMonth && highlightedDays.includes(day.date());

  return (
    <PickersDay
      {...other}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      sx={{
        ...other.sx,
        width: 32,
        height: 32,
        ...(isHighlighted && !other.selected && {
          backgroundColor: 'primary.background',
          '&:hover': {
            backgroundColor: 'primary.light',
          },
        }),
      }}
    />
  );
}
